(function () {
    if (window.HomeBanner) {
        window.HomeBanner.init(document);
        return;
    }

    window.HomeBanner = {
        breakpoint: window.matchMedia('(max-width: 768px)'),
        reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)'),
        zoomItems: [],
        zoomFrame: null,

        setupImageZoom: function () {
            window.HomeBanner.zoomItems = Array.from(document.querySelectorAll('[data-home-banner][data-imgzoom] img'));

            if (window.HomeBanner.zoomItems.length) {
                window.HomeBanner.bindImageZoom();
            }

            if (!window.HomeBanner.zoomItems.length || window.HomeBanner.reducedMotion.matches) {
                window.HomeBanner.zoomItems.forEach(function (image) {
                    image.style.setProperty('--home-banner-image-scale', '1');
                });
                return;
            }

            window.HomeBanner.updateImageZoom();
        },

        updateImageZoom: function () {
            window.HomeBanner.zoomFrame = null;

            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            window.HomeBanner.zoomItems.forEach(function (image) {
                const rect = image.getBoundingClientRect();
                const animationDistance = viewportHeight + rect.height * 0.5;
                const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / animationDistance));
                const scale = 1.2 - progress * 0.2;

                image.style.setProperty('--home-banner-image-scale', scale.toFixed(4));
            });
        },

        requestImageZoomUpdate: function () {
            if (window.HomeBanner.zoomFrame || window.HomeBanner.reducedMotion.matches) {
                return;
            }

            window.HomeBanner.zoomFrame = window.requestAnimationFrame(window.HomeBanner.updateImageZoom);
        },

        bindImageZoom: function () {
            if (window.HomeBanner.imageZoomBound) {
                return;
            }

            window.addEventListener('scroll', window.HomeBanner.requestImageZoomUpdate, { passive: true });
            window.addEventListener('resize', window.HomeBanner.requestImageZoomUpdate);

            if (window.HomeBanner.reducedMotion.addEventListener) {
                window.HomeBanner.reducedMotion.addEventListener('change', window.HomeBanner.setupImageZoom);
            } else {
                window.HomeBanner.reducedMotion.addListener(window.HomeBanner.setupImageZoom);
            }

            window.HomeBanner.imageZoomBound = true;
        },

        setupVideoSequence: function (banner, slider) {
            const getSlides = function () {
                const slides = Array.from(slider.querySelectorAll('.swiper-slide'));

                if (!window.HomeBanner.breakpoint.matches) {
                    return slides;
                }

                return slides.filter((slide) => !slide.classList.contains('home-banner__slide--hidden-mobile'));
            };

            const getVideo = function (slide) {
                if (window.HomeBanner.breakpoint.matches) {
                    return slide.querySelector('.media-mobile') || slide.querySelector('.media-desktop');
                }

                return slide.querySelector('.media-desktop');
            };

            const playSlide = function (slide) {
                const slides = getSlides();
                const video = getVideo(slide);

                slider.querySelectorAll('video').forEach((item) => {
                    item.pause();
                });

                if (!video) {
                    return;
                }

                video.currentTime = 0;

                if (window.HomeBanner.breakpoint.matches && slider.swiper) {
                    slider.swiper.slideTo(slides.indexOf(slide));
                }

                const playPromise = video.play();

                if (playPromise) {
                    playPromise.catch(function () {});
                }
            };

            if (!banner.dataset.videoSequenceReady) {
                slider.querySelectorAll('video').forEach((video) => {
                    video.addEventListener('ended', function () {
                        const slides = getSlides();
                        const currentSlide = video.closest('.swiper-slide');
                        const currentIndex = slides.indexOf(currentSlide);
                        const nextSlide = slides[(currentIndex + 1) % slides.length];

                        if (nextSlide) {
                            playSlide(nextSlide);
                        }
                    });
                });

                banner.dataset.videoSequenceReady = 'true';
            }

            const firstSlide = getSlides().find((slide) => getVideo(slide));

            if (firstSlide) {
                playSlide(firstSlide);
            }
        },

        init: function (scope) {
            const root = scope || document;

            root.querySelectorAll('[data-home-banner]').forEach((banner) => {
                const slider = banner.querySelector('.home-banner__slider');

                if (!slider) {
                    return;
                }

                const visibleSlides = slider.querySelectorAll('.swiper-slide:not(.home-banner__slide--hidden-mobile)');
                const hasVideoSequence = banner.hasAttribute('data-sequential-videos');

                if (window.HomeBanner.breakpoint.matches && visibleSlides.length > 1 && !slider.swiper) {
                    new Swiper(slider, {
                        slidesPerView: 1,
                        effect: 'fade',
                        loop: !hasVideoSequence,
                        autoplay: hasVideoSequence ? false : {
                            delay: 5000,
                            disableOnInteraction: false,
                        }
                    });
                } else if ((!window.HomeBanner.breakpoint.matches || visibleSlides.length < 2) && slider.swiper) {
                    slider.swiper.destroy(true, false);
                }

                if (hasVideoSequence) {
                    window.HomeBanner.setupVideoSequence(banner, slider);
                }
            });

            window.HomeBanner.setupImageZoom();
        }
    };

    document.addEventListener('DOMContentLoaded', function () {
        window.HomeBanner.init(document);
        window.HomeBanner.breakpoint.addEventListener('change', function () {
            window.HomeBanner.init(document);
        });
    });

    document.addEventListener('shopify:section:load', function (event) {
        window.HomeBanner.init(event.target);
    });
}());
